document.addEventListener("DOMContentLoaded", function(event) {
  retrievePoints();
  
  let listPositions = document.querySelector(".listPositions");
  let buttonUp = document.getElementById("buttonUp");
  buttonUp.addEventListener("click", e=>{
    if(listPositions.classList.contains("up")){
       listPositions.classList.remove("up");
       buttonUp.classList.remove("rotate");
       document.body.classList.remove("overflow-y");
    }
    else{
       listPositions.classList.add("up");
       buttonUp.classList.add("rotate");
       document.body.classList.add("overflow-y");
    }
  });
  
});
var POINT_DATA;
var MAP;

async function retrievePoints(){
  var data = new FormData();
  data.append( "request", "request" );
  fetch('https://contacts.pastiglieleone.com/store-request.php', {
    method: 'POST', // or 'PUT'
    body: data,
  })
  .then(response => response.json())
  .then(data => {
    console.log(data);
    POINT_DATA = data;
    MAP = L.map('leaflet', {
      center: new L.LatLng(41.8651251, 10.7790812),
      zoom: 6,
      maxZoom: 18,
      gestureHandling: true,
    });

    // add the OpenStreetMap tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>'
    }).addTo(MAP);

    var markers = L.markerClusterGroup({
      showCoverageOnHover: false,
      animate: true
    });
    
	var pinIcon = L.icon({
      iconUrl: 'https://contacts.pastiglieleone.com/images/pin-leone.svg',

      iconSize:     [40, 50],
      iconAnchor:   [20, 50],
      popupAnchor:  [0, -50],
    });
    
    Object.keys(data).forEach(function(pointList){
      Object.keys(data[pointList]).forEach(function(point){
        var store = data[pointList][point];
        var marker = new L.Marker({
          lon: store.lng,
          lat: store.lat
        }, {icon: pinIcon});
        marker.bindPopup("<h4 class='text-center titleLev5 alternative colorBlue'>" + store.titolo + "</h4><p class='text-center smallParagraph'>" + store.indirizzo + "<br>" + store.comune + " (" + store.provincia + ")" + "<br><a class='storeBtn' href='https://www.google.it/maps/?q=" + store.lat + "," + store.lng+ "' target='_blank'>Portami qui</a><p>");
        markers.addLayer(marker);
      });
    });

    MAP.addLayer(markers);
    print_first_slide();
    initSlider();
    return data;
  })
  .catch((error) => {
    console.log('Error:', error);
  });
}

function initSlider(){
  $("#slider").slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    adaptiveHeight: true
  });
}

function print_first_slide(){
  document.getElementById("province").innerHTML = '';
  Object.keys(POINT_DATA).forEach(function(province){
    document.getElementById("province").innerHTML += '<div class="provinciaSingola" onClick="print_second_slide(\''+province+'\')">' +
      '<span class="titleLev5 alternative colorBlue">'+province+'</span>'
    '</div>';
  });
}

function print_second_slide(provincia){
  document.getElementById("stores").innerHTML = '<div class="secondSlideHeader" onClick="goto_first_slide()"><h3 class="m-0 titleLev4 alternative">'+provincia+'</h3><span class="arrow"><</span></div>';
  arrayOfLatLngs = new Array();
  Object.keys(POINT_DATA[provincia]).forEach(function(punti){
    var elem = POINT_DATA[provincia][punti];
    var titolo = elem.titolo;
    var indirizzo = elem.indirizzo;
    var cap = elem.cap;
    var localita = elem.comune;

    document.getElementById("stores").innerHTML += '<div class="negozioSingolo" onClick="goto_store(\''+provincia+'\', \''+punti+'\')"><div class="inner colorBlue">' +
      '<span class="h6 text-uppercase">'+titolo+'</span>' +
      '<p class="small mb-0 pallino">'+indirizzo+'</span>' +
      '<p class="small mb-0 pallino">'+cap+' '+localita+'</span>' +
    '</div></div>';
    arrayOfLatLngs.push([elem.lat, elem.lng]);
  });
  MAP.fitBounds(new L.LatLngBounds(arrayOfLatLngs));
  $("#slider").slick("next");
  document.querySelector('#sliderContainer').scrollTop = 0;
}

function goto_store(provincia, punto){
  var elem = POINT_DATA[provincia][punto];
  MAP.setView([elem.lat, elem.lng], 17);
  let listPositions = document.querySelector(".listPositions");
  let buttonUp = document.getElementById("buttonUp");
  listPositions.classList.remove("up");
  buttonUp.classList.remove("rotate");
  document.body.classList.remove("overflow-y");
  if(window.innerWidth < 992){
    goto_first_slide();
  }
}

function goto_first_slide(){
  $("#slider").slick("prev");
  
  if(window.innerWidth >= 992){
  	MAP.setView([41.8651251, 10.7790812], 6);
  }
}
